// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';

import type {ScrollControl} from './index';

export function template(this: ScrollControl) {
  const {endControlAvailable, endControlVisible, startControlAvailable, startControlVisible} = this.state;

  return (
    <div sel='.scroll-control' style={this.helpers.getStyle()}>
      <div sel='.scroll-back-container' class={{visible: startControlVisible}}>
        {startControlAvailable ? (
          <div
            sel='.scroll-button'
            attrs={{
              role: `button`,
              tabindex: 0,
            }}
            on={{
              click: this.helpers.scrollBack,
            }}
          >
            <SvgIconEl attrs={{icon: `arrow-left`}} />
          </div>
        ) : null}
      </div>
      <div sel='.scroll-forward-container' class={{visible: endControlVisible}}>
        {endControlAvailable ? (
          <div
            sel='.scroll-button'
            attrs={{
              role: `button`,
              tabindex: 0,
            }}
            on={{
              click: this.helpers.scrollForward,
            }}
          >
            <SvgIconEl attrs={{icon: `arrow-right`}} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
